import { BUILD_VERSION } from "config/buildVersion";

const VERSION_STORAGE_KEY = "travelbay_recovery_version";

// The only browser-persisted app state this codebase writes today (confirmed
// by auditing every localStorage/sessionStorage/indexedDB call site — MobX
// stores and Apollo's InMemoryCache are both purely in-memory and never
// persisted). Deliberately an explicit allowlist, never a prefix sweep or
// storage.clear() — auth cookies, Firebase's own storage, and anything else
// in the browser must survive this untouched.
const STALE_SESSION_KEYS = ["account_type", "email", "chatHistory"];

/**
 * One-time, idempotent cleanup that runs before Apollo/MobX are constructed.
 * If the recovery version on disk doesn't match the build's version, drop
 * the known stale session keys and record the new version. Safe to re-run
 * (e.g. if interrupted mid-way) since removing an already-absent key is a
 * no-op and the version is only written after the removals succeed.
 */
export const runRecoveryMigration = () => {
  let storedVersion = null;
  try {
    storedVersion = window.localStorage.getItem(VERSION_STORAGE_KEY);
  } catch {
    // Storage unavailable (privacy mode, disabled cookies, etc) — nothing to migrate.
    return;
  }

  if (storedVersion === BUILD_VERSION) return;

  STALE_SESSION_KEYS.forEach((key) => {
    try {
      window.sessionStorage.removeItem(key);
    } catch {
      // ignore — sessionStorage may be unavailable in some environments
    }
  });

  try {
    window.localStorage.setItem(VERSION_STORAGE_KEY, BUILD_VERSION);
  } catch {
    // If this write fails, the next load retries the same (idempotent) cleanup.
  }
};
